export default __webpack_public_path__ + "static/media/i044vk.3af79ff7.webp";